<script lang="ts">
    export let initialJobs: Array<{
        id: string;
        title: string;
        description: string;
        companyName: string;
        companySlug: string;
        location: string;
        postedDate: string;
        webUrl: string | null;
        slug: string;
        logoUrl: string | null;
    }>;
    export let initialHasMore: boolean = true;
    export let initialPageSize: number = 6;

    let jobs = initialJobs;
    let loading = false;
    let error: string | null = null;
    // Start from page 1 since page 0 was already loaded on the server
    let currentPage = 1;
    let hasMore = initialHasMore;
    const pageSize = 6;

    async function loadMoreJobs() {
        if (loading || !hasMore) return;

        loading = true;
        error = null;

        try {
            const urlParams = new URLSearchParams(window.location.search);
            const keyword = urlParams.get('keyword') || '';
            const industry = urlParams.get('industry') || '';
            const location = urlParams.get('location') || '';

            let url = `/api/jobs?page=${currentPage}&size=${pageSize}`;
            if (keyword) url += `&keyword=${encodeURIComponent(keyword)}`;
            if (industry) url += `&industry=${encodeURIComponent(industry)}`;
            if (location) url += `&location=${encodeURIComponent(location)}`;

            const res = await fetch(url);
            if (!res.ok) throw new Error('Failed to load jobs');

            const data = await res.json();
            jobs = [...jobs, ...data.jobs];
            hasMore = data.hasMore;
            currentPage++;
        } catch (err) {
            error = err instanceof Error ? err.message : 'Unknown error';
        } finally {
            loading = false;
        }
    }

    function formatDate(iso: string): string {
        if (!iso) return '';
        const d = new Date(iso);
        if (isNaN(d.getTime())) return '';
        return `${d.getMonth() + 1}/${d.getDate()}`;
    }
</script>

{#if jobs.length === 0}
    <p class="muted" style="font-style: italic; padding: 20px 0; text-align: center;">nothing matches. try fewer filters.</p>
{:else}
    <ul class="jobs">
        {#each jobs as job}
            <li>
                <span class="date">{formatDate(job.postedDate)}</span>
                <a href="/jobs/{job.slug}">{job.title} &mdash; {job.companyName}</a>
                {#if job.location}
                    <span class="tag">{job.location}</span>
                {/if}
            </li>
        {/each}
    </ul>
{/if}

{#if error}
    <p class="flash err" style="margin-top: 14px;">{error}</p>
{/if}

{#if hasMore}
    <p class="load-more-wrap">
        <button class="load-more" on:click={loadMoreJobs} disabled={loading}>
            {loading ? 'loading...' : 'load more'}
        </button>
    </p>
{/if}
